import React from 'react'
import pluralize from 'pluralize'
import { Segment } from 'components/commodity_code_picker/picker/Segment'

export interface SelectedSegmentsProps {
  handleClick: (segment: Segment) => void
  handleRemove: (segment: Segment) => void
  selectedSegments: Segment[]
}

const SelectedSegments: React.FC<SelectedSegmentsProps> = ({ handleClick, handleRemove, selectedSegments }) => {
  return (
    <div id='selected-segments' data-testid='selected-segments'>
      <div
        className={
          selectedSegments.length > 0
            ? 'selected-title-bar blue-bar cell small-12'
            : 'selected-title-bar grey-bar cell small-12'
        }
      >
        <div className='grid-x align-justify selected-segments-header'>
          <div className='cell shrink'>
            <h3>Selected UNSPSC</h3>
          </div>
          <div className='cell shrink'>
            <span>{selectedSegments.length}</span>
          </div>
        </div>
      </div>

      <div className='scrollable-container'>
        {selectedSegments.sort((a, b) => a.item_description > b.item_description ? 1 : -1).map((segment) => {
          const familiesCount: number = segment.families.length
          const classesCount: number = segment.families.reduce((count: number, family) => {
            const commodityCount: number = family.commodities.length
            return count + commodityCount
          }, 0)

          return (
            <div className='grid-x align-middle segment-container' key={segment.id}>
              <div className='cell auto'>
                <div className='segment-header'>SEGMENT {segment.code}</div>
                <div className='segment-name'>
                  <span className='name'>{segment.item_description}</span>
                </div>
                <div className='segment-stats grid-x grid-margin-x'>
                  <div className='stat-text cell small-12 large-auto cell'>
                    {`${familiesCount} ${pluralize('family', familiesCount)} and ${classesCount} ${pluralize('class', classesCount)} selected`}
                  </div>
                  <div
                    className='remove-segment pointer-clickable small-12 large-shrink cell'
                    onClick={() => handleRemove(segment)}
                  >
                    Remove Segment
                  </div>
                </div>
              </div>
              <button
                className='cell shrink pointer-clickable'
                onClick={() => handleClick(segment)}
              >
                <i className='fal fa-angle-right caret' title='Go to segment' />
              </button>
            </div>
          )
        })}
        <div className='prompt'>
          Your selected UNSPSC codes will appear here. Start by selecting your
          codes on the right.
        </div>
      </div>
    </div>
  )
}

export default SelectedSegments
